export default __webpack_public_path__ + "static/assets/1b73747e05f1e66f7e2530eebfa504c0.gif";